module.exports = __webpack_public_path__ + "media/images/top/common/img_voice_result01-e8d6b993bddcfd7f0119f9e7d908ff61.png";